export default {
  getErrorResponse: state => {
    return state.error
  },

  isAppReady: state => {
    return state.appReady
  },

  getLoginData: state => {
    return state.loginData
  },

  getAllRooms: state => {
    let rooms = state.allRooms.response.data
    let result = {}
    let skills = []
    let tempWaiting
    rooms.forEach((element) => {
      if (skills.indexOf(element.skill) === -1) {
        skills.push(element.skill)
      }
    })
    result.created = rooms.filter(room => room.status === 'created') // The room is created. Created rooms should not be show in the UI.
    result.running = rooms.filter(room => room.status === 'running') // An agent took the room. If the agent is not the current agent, the room should not be show.
    result.closed = rooms.filter(room => room.status === 'closed') // The room is closed. End of the discussion.
    result.late = rooms.filter(room => room.status === 'late') // The guest wait a response for too long. If the agent is not the current agent, the room should not be show.
    result.blocked = rooms.filter(room => room.status === 'blocked') // The room (and the guest) is blocked. This room should not be show.
    tempWaiting = rooms.filter(room => room.status === 'waiting' || room.status === 'transferred') // The room wait an agent.
    result.waiting = {}
    skills.forEach(item => {
      let tempW = tempWaiting.filter(room => room.skill === item)
      if (tempW.length > 0) {
        result.waiting[state.allSkills.response.data['_' + item].label] = tempW
      }
    })
    return result
  },

  getSkills: state => {
    return state.allSkills.response.data
  },

  getCurrentRoom: state => {
    if (state.currentRoomUuid) {
      return state.allRooms.response.data[('_' + state.currentRoomUuid)]
    } else {
      return false
    }
  },

  getCurrentRoomUuid: state => {
    return state.currentRoomUuid
  },

  getMessages: state => {
    return state.messages.response.messages
  },

  getAllAgents: state => {
    return state.allAgents.response.data
  },

  getAgentsBySkill: state => {
    let skills = state.allSkills.response.data
    let agents = state.allAgents.response.data
    let result = {}
    skills.forEach(skill => {
      result[skill.label] = {
        label: skill.label,
        uuid: skill.uuid,
        data: []
      }
      agents.forEach(agent => {
        if (agent.skills.filter(agSkill => agSkill.uuid === skill.uuid).length > 0) {
          result[skill.label].data.push(agent)
        }
      })
    })
    return result
  },

  getAgentSettings: state => {
    return state.agentSettings.response.data
  },

  getOwnSettings: state => {
    return state.ownSettings.response.data
  },

  getCurrentTransferSkill: state => {
    return state.transferRoom.request.skill
  },

  getTransferRoomResponse: state => {
    return state.transferRoom.response
  },

  getJoinRoomResponse: state => {
    return state.joinRoom.response
  },

  getBlockRoomResponse: state => {
    return state.blockRoom.response
  },

  getCloseRoomResponse: state => {
    return state.closeRoom.response
  },

  getHistoryResponse: state => {
    return state.getHistory.response
  },

  getSendMessageRequestObject: state => {
    return state.sendMessage.request
  },

  getProducts: state => {
    return state.getProducts.response.data
  },

  getHeaderStats: state => {
    return state.getHeaderStats.response.data
  },

  getStats: state => {
    return state.getStats.response.data
  },

  getCsvStats: state => {
    return state.getCsvStats.response.data
  },

  getIntervalsForStats: state => {
    return state.intervals
  },

  getSupervisorStats: state => {
    return state.getSupervisorStats.response.data
  },

  getSupervisorCsvStats: state => {
    return state.getSupervisorCsvStats.response.data
  },

  getNotes: state => {
    return state.getNotes.response
  },

  getPendingRequests: state => {
    return state.pendingRequests
  },

  getSendNoteResponse: state => {
    return state.sendNote.response
  },

  getSendNoteRequest: state => {
    return state.sendNote.request
  },

  getMainTime: state => {
    return state.mainTime
  },

  getZencalls: state => {
    return state.getZencalls.response.data
  },

  getLaunchZencall: state => {
    return state.launchZencall.response
  },

  getCrmResults: state => {
    return state.crm.results
  }
}
